import type { BackfillComputed } from '@/features/tasks';
import { isEmptyString } from '@/utils/string';
import { capitalize } from 'lodash-es';

/**
 * Builds consistent display parts for a task (backfill) for use in messages, titles, and snackbars.
 */
export function getTaskDisplayParts(
  backfill: BackfillComputed | undefined | null,
  options: {
    displayTextFallback?: string;
    objectTypeFallback?: string;
  } = {},
): { displayText: string; objectTypeDisplay: string; taskDisplay: string } {
  const { displayTextFallback = 'Task', objectTypeFallback = '' } = options;

  const hasObjectName = !isEmptyString(backfill?.object_name);
  const displayText = (hasObjectName ? backfill?.object_name : backfill?.info.label) ?? displayTextFallback;
  const objectTypeDisplay =
    backfill?.info.objectType === 'sql-import'
      ? hasObjectName
        ? backfill?.info.label ?? objectTypeFallback
        : objectTypeFallback
      : capitalize(backfill?.info.objectType ?? objectTypeFallback);

  const parts = [objectTypeDisplay, displayText].filter(Boolean);
  const combined = parts.length === 2 && parts[0] === parts[1] ? parts[0] : parts.join(' ').trim();
  const taskDisplay = isEmptyString(combined) ? displayTextFallback : combined;

  return { displayText, objectTypeDisplay, taskDisplay };
}
